
  import { defineComponent, PropType } from 'vue';

  import { TTableTreeColumnConfig } from '@/common/components/redesigned/Table/types/tableTypes';
  import { TStorePaths } from '@/common/types/storePaths';

  import {
    STATISTICS_PUBLIC_ACTIONS_NAME,
    STATISTICS_PUBLIC_GETTERS_NAME,
    STATISTICS_PUBLIC_MUTATIONS_NAME,
  } from '../../../store/statisticsPublic/name';
  import { TBaseViewsCountTableItem } from '../../../types/statistics/common';
  import { TStatisticsPublicFilter } from '../../../types/statistics/statistics-public';
  import StatisticsViewsCountByNavigationTab from '../StatisticsViewsCountByNavigationTab.vue';

  export default defineComponent({
    name: 'StatisticsPublicViewsCountByNavigationTab',
    components: {
      StatisticsViewsCountByNavigationTab,
    },
    props: {
      filter: {
        type: Object as PropType<TStatisticsPublicFilter>,
        required: true,
      },
    },
    data(): {
      firstStorePaths: TStorePaths;
      secondStorePaths: TStorePaths;
      viewsCountColumn: TTableTreeColumnConfig<TBaseViewsCountTableItem>;
    } {
      return {
        firstStorePaths: {
          action: STATISTICS_PUBLIC_ACTIONS_NAME.getSectionsTable,
          mutation: STATISTICS_PUBLIC_MUTATIONS_NAME.setSectionsTable,
          getter: STATISTICS_PUBLIC_GETTERS_NAME.getSectionsTable,
        },
        secondStorePaths: {
          action: STATISTICS_PUBLIC_ACTIONS_NAME.getPagesTable,
          mutation: STATISTICS_PUBLIC_MUTATIONS_NAME.setPagesTable,
          getter: STATISTICS_PUBLIC_GETTERS_NAME.getPagesTable,
        },
        // ? ширина рассчитана так, чтобы заголовок помещался в одну строку
        viewsCountColumn: {
          field: 'viewsCount',
          title: 'Авторизованные/Неавторизованные',
          textAlign: 'right',
          sortable: true,
          width: 300,
        },
      };
    },
  });
